import React, { Component } from 'react';
import moment from 'moment';
import xsmallLoader from '../assets/loader-xs.svg';
import inputLoader from '../assets/input-loader.svg';
import textLogo from '../assets/logo-text.svg';
import bg from '../assets/enrol-bg.png';
import {baseUrl} from './url';

class EnrollmentForm extends Component{
    constructor(props){
        super(props)
        this.state = {
            userType: this.props.userType,
            states: [],
            lgas: [],
            prefix: '',
            first_name: '',
            last_name: '',
            phone_no: '',
            sex: '',
            dob: '',
            marital_status: '',
            address: '',
            state: '',
            lga: '',
            weight: '',
            height: '',
            occupation: '',
            referral: '',
            sod: '',
            treatment_no: '',

            prefixError: '',
            first_nameError: '',
            last_nameError: '',
            phone_noError: '',
            sexError: '',
            dobError: '',
            marital_statusError: '',
            addressError: '',
            stateError: '',
            lgaError: '',
            weightError: '',
            heightError: '',
            occupationError: '',
            referralError: '',
            sodError: '',
            page_error: '',
            treatment_noError: '',

            noResponse: true,
            treatmentResponse: true,
            aliasResponse: true,
            phone_noResponse: true,
            lgaResponse: true,
        }
        // this.handleNextPage = this.handleNextPage.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.checkUnique = this.checkUnique.bind(this);
        this.handleLgas =  this.handleLgas.bind(this);
    }
    componentWillMount(){
        let states = []
        fetch(`http://locationsng-api.herokuapp.com/api/v1/states`,{
            method: 'GET',
        })
        .then((response) => response.json())
        .then((responseJson) => {
            states = responseJson.map((state) => {
                return state.name
            });
            this.setState({
                states,
            })
        })
    }
    handleLgas(){
        this.setState({
            lgaResponse: false
        })
        fetch(`http://locationsng-api.herokuapp.com/api/v1/states/${this.state.state}/lgas`,{
            method: 'GET',
        })
        .then((response) => response.json())
        .then((responseJson) => {
            this.setState({
                lgas: responseJson,
                lgaResponse: true
            })
        })
    }
    handleChange(e){
        let number = /^(0[7-9][01])\d{8}$|(\+[0-9-]+)\d$/.test(e.target.value);
        
        this.setState({ 
            [e.target.name]: e.target.value,
            [e.target.name + 'Error']: '',
            page_error: ''
        })
        if(e.target.name === 'phone_no'){
            // if(e.target.value.length >= 8){
                if(!number){
                    this.setState({
                        phone_noError: 'Please enter a valid phone number'
                    })
                }
        }
        if(e.target.name === 'weight'){
            if(e.target.value < 30 || e.target.value > 70){
                this.setState({
                    weightError: 'Weight should be between 30 & 70'
                })
            }
        }
        if(e.target.name === 'dob'){
            let dob = moment(e.target.value);
            let currDate = moment();
            let diff = currDate.diff(dob, 'years');

            if(diff < 15){
                this.setState({
                    dobError: "Age shouldn't be less than 15"
                })
            }
        }
        if((e.target.name === 'alias' || e.target.name === 'treatment_no' || e.target.name === 'phone_no') && e.target.value.length > 0){
            this.checkUnique(e.target.name, e.target.value);
        }
    }
    checkUnique(item, value){
        if(item === 'alias'){
            this.setState({
                aliasResponse: false
            })
        }
        if(item === 'treatment_no'){
            this.setState({
                treatmentResponse: false
            })
        }
        if(item === 'phone_no'){
            this.setState({
                phone_noResponse: false
            })
        }
        const token = localStorage.getItem('access_token');
        fetch(`${baseUrl}/unique?item=${item}&value=${value}`,{
            method: 'GET',
            headers: {
                'Authorization': token
            }
        })
        .then((response) => {
            response.json()
            if(item === 'alias'){
                this.setState({
                    aliasResponse: true
                })
            }
            if(item === 'treatment_no'){
                this.setState({
                    treatmentResponse: true
                })
            }
            if(item === 'phone_no'){
                this.setState({
                    phone_noResponse: true
                })
            }
            if(response.status === 409){
                if(item === 'alias'){
                    this.setState({
                        aliasError: 'Alias is already in use.'
                    })
                }
                else if(item === 'phone_no'){
                    this.setState({
                        phone_noError: 'Phone number is already in use.'
                    })
                }
                else if(item === 'treatment_no'){
                    this.setState({
                        treatment_noError: 'Treatment number already exists.',
                        treatmentResponse: true
                    })
                }
            }
        })
    }
    handleSubmit(e){
        e.preventDefault();
        const {
            prefix,
            first_name,
            last_name,
            phone_no,
            sex,
            dob,
            marital_status,
            address,
            state,
            lga,
            weight,
            height,
            occupation,
            referral,
            sod,
            treatment_no,
            treatment_noError,
            phone_noError,
            dobError,
        } = this.state;

        if(!prefix){
            this.setState({
                prefixError: 'Please select one'
            })
        }
        if(!first_name){
            this.setState({
                first_nameError: 'This field cannot be empty'
            })
        }
        if(!last_name){
            this.setState({
                last_nameError: 'This field cannot be empty'
            })
        }
        if(!phone_no){
            this.setState({
                phone_noError: 'This field cannot be empty'
            })
        }
        else if(phone_no.length < 11){
            this.setState({
                phone_noError: 'Please enter a valid phone number'
            })
        }
        if(!marital_status){
            this.setState({
                marital_statusError: 'Please select one'
            })
        }
        if(!sex){
            this.setState({
                sexError: 'Please select one'
            })
        }
        if(!dob){
            this.setState({
                dobError: 'This field cannot be empty'
            })
        }
        if(!address){
            this.setState({
                addressError: 'This field cannot be empty'
            })
        }
        if(!state){
            this.setState({
                stateError: 'Please select one'
            })
        }
        if(!lga){
            this.setState({
                lgaError: 'Please select one'
            })
        }
        if(!weight){
            this.setState({
                weightError: 'This field cannot be empty'
            })
        }
        if(!height){
            this.setState({
                heightError: 'This field cannot be empty'
            })
        }
        if(!occupation){
            this.setState({
                occupationError: 'This field cannot be empty'
            })
        }
        if(!treatment_no){
            this.setState({
                treatment_noError: 'This field cannot be empty'
            })
        }
        if(!referral){
            this.setState({
                referralError: 'This field cannot be empty'
            })
        }
        if(!sod){
            this.setState({
                sodError: 'This field cannotbe empty'
            })
        }
        if(prefix && first_name && last_name && phone_no && sex && dob && address && marital_status && weight && height && occupation && treatment_no && !treatment_noError && !phone_noError && lga && state && !dobError){
            this.props.handleStep2();
        }else{
            this.setState({
                page_error: 'There are errors on this page'
            })
        }
    }
    // handleSubmit(e){
    //     e.preventDefault();
    //     const {
    //         no_of_children,
    //         history_of_intake,
    //         referral,
    //         sod,
    //         treatment_phase,
    //         treatment_time,
    //         caregiver_name,
    //         treatment_start_date
    //     } = this.state;

    //     if(!no_of_children){
    //         this.setState({
    //             no_of_childrenError: 'This field cannot be empty'
    //         })
    //     }
    //     if(!history_of_intake){
    //         this.setState({
    //             history_of_intakeError: 'This field cannot be empty'
    //         })
    //     }
    //     if(!referral){
    //         this.setState({
    //             referralError: 'This field cannot be empty'
    //         })
    //     }
    //     if(!sod){
    //         this.setState({
    //             sodError: 'This field cannot be empty'
    //         })
    //     }
    //     if(!treatment_phase){
    //         this.setState({
    //             treatment_phaseError: 'This field cannot be empty'
    //         })
    //     }
    //     if(!treatment_time){
    //         this.setState({
    //             treatment_timeError: 'This field cannot be empty'
    //         })
    //     }
    //     if(!caregiver_name){
    //         this.setState({
    //             caregiver_nameError: 'This field cannot be empty'
    //         })
    //     }
    //     if(!treatment_start_date){
    //         this.setState({
    //             treatment_start_dateError: 'This field cannot be empty'
    //         })
    //     }
    //     if(no_of_children && history_of_intake && referral && sod && treatment_phase && treatment_time && caregiver_name && treatment_start_date){
    //         const token = localStorage.getItem('access_token');
    //         let dateObj = moment(this.state.dob, 'YYYY-MM-DD');
    //         let date = dateObj.format('DD-MM-YYYY');

    //         let tdateObj = moment(this.state.treatment_start_date, 'YYYY-MM-DD');
    //         let tdate = tdateObj.format('DD-MM-YYYY');

    //         // let timeObj = moment(this.state.treatment_time, 'HH:mm');
    //         // let time = timeObj.format('hh:mm A');

    //         let today = moment().format('YYYY-MM-DD');

    //         let retries = 0;
    //         this.setState({
    //             noResponse: false
    //         })
    //         fetch(`${baseUrl}/admin/users/create`,{
    //             method: 'POST',
    //             headers: {
    //                 'Accept': 'application/json',
    //                 'Content-Type': 'application/json',
    //                 'Authorization': token
    //             },
    //             body: JSON.stringify({
    //                 "type": this.state.userType,
    //                 "prefix": this.state.prefix,
    //                 "first_name": this.state.first_name,
    //                 "last_name": this.state.last_name,
    //                 "alias": this.state.alias,
    //                 "phone_no": this.state.phone_no,
    //                 "sex": this.state.sex,
    //                 "dob": date,
    //                 "marital_status": this.state.marital_status,
    //                 "address": this.state.address,
    //                 "lga": this.state.lga,
    //                 "state": this.state.state,
    //                 "weight": this.state.weight,
    //                 "height": this.state.height,
    //                 "occupation": this.state.occupation,
    //                 "no_of_children": this.state.no_of_children,
    //                 "history_of_intake": this.state.history_of_intake,
    //                 "referral": this.state.referral,
    //                 "sod": this.state.sod,
    //                 "treatment_phase": this.state.treatment_phase,
    //                 "treatment_no": this.state.treatment_no,
    //                 "treatment_time": moment(today + ' ' + this.state.treatment_time).format('hh:mm A'),
    //                 "caregiver_id": this.state.caregiver_id,
    //                 "caregiver_name": this.state.caregiver_name,
    //                 "treatment_start_date": tdate
    //             })
    //         })
    //         .then((response) => {
    //             const auth = response.headers.get('Authorization');
    //             localStorage.setItem('access_token', auth);
    //             return response.json();
    //         })
    //         .then((responseJson) => {
    //             if (responseJson.hasOwnProperty('message')){
    //                 if(responseJson.message === 'Patient successfully created.'){
    //                     let user_id = responseJson.patient.patient_id,
    //                         user_type = 'patient';
    //                     localStorage.setItem('user_type',JSON.stringify(user_type));
    //                     localStorage.setItem('user_id',JSON.stringify(user_id));
    //                     localStorage.setItem('new_patient',JSON.stringify(true));

    //                     this.setState({
    //                         noResponse: true,
    //                     })
    //                     this.props.history.push(`/patient`);
    //                 }
    //             }
    //         })
    //         .catch((error)=>{
    //             if (error === 401 && retries < 1){
    //                 localStorage.getItem('access_token')
    //                 .then(value => {
    //                     fetch(`${baseUrl}/token/refresh'`,{
    //                         headers: {
    //                             'Accept': 'application/json',
    //                             'Authorization': value
    //                         }
    //                     }).then(response => {
    //                         retries += 1;
    //                         if(response.status === 200){
    //                             localStorage.setItem('access_token', response.headers.get('Authorization'));
    //                             this.handleSubmit();
    //                         }
    //                         else{
    //                             alert('something went wrong please try again later');
    //                         }
    //                     })
    //                 })
    //             }
    //             else{
    //                 alert('something went wrong please try again later');
    //             }
    //         })
    //     }else{
    //         this.setState({
    //             page_error: 'There are errors on this page'
    //         })
    //     }
    // }
    render(){
        let {treatmentResponse, phone_noResponse, states, lgas, lgaResponse } = this.state;
        
        let stateOption = states.map((state, index) => 
            <option key={index}>{state === 'Federal Capital Territory'?'Abuja':state}</option>
        )
        let lgaOption = lgas.map((lga, index) => 
            <option key={index}>{lga}</option>
        )
        return(
            <div className="enrollment-form">
                <img src={bg} alt="" className='bg'/>
                <div className="container">
                <div className="row">
                    <div className="col-sm-8 offset-sm-2">
                        <h3>Enrollment Form</h3>
                        <div className="form-card">
                            <img src={textLogo} alt="" className="logo"/>
                            <div className="form">
                                <form onSubmit={this.handleSubmit}>
                                    <div>
                                        <input type="hidden" name="type" value={this.state.userType}/>
                                        <label>
                                            Clinic Number
                                            <input 
                                                type="text" 
                                                name="treatment_no" 
                                                className={this.state.treatment_noError && 'error-input'} 
                                                onChange={this.handleChange}
                                                value={this.state.treatment_no}/>
                                            {!treatmentResponse && <img src={inputLoader} alt='' className='input-loader'/>}
                                            <span className="error-text">{this.state.treatment_noError}</span>
                                        </label>
                                        <label>
                                            Title
                                            <select 
                                                name="prefix" 
                                                className={this.state.prefixError && 'error-input'} 
                                                onChange={this.handleChange}
                                                value={this.state.prefix}>
                                                <option value="">Select...</option>
                                                <option value="dr">Dr</option>
                                                <option value="mr">Mr</option>
                                                <option value="mrs">Mrs</option>
                                                <option value="ms">Ms</option>
                                            </select>
                                            <span className="error-text">{this.state.prefixError}</span>
                                        </label>
                                        <label>
                                            First Name
                                            <input 
                                                type="text" 
                                                name="first_name" 
                                                className={this.state.first_nameError && 'error-input'} 
                                                onChange={this.handleChange}
                                                value={this.state.first_name}/>
                                            <span className="error-text">{this.state.first_nameError}</span>
                                        </label>
                                        <label>
                                            Last Name
                                            <input 
                                                type="text" 
                                                name="last_name" 
                                                className={this.state.last_nameError && 'error-input'} 
                                                onChange={this.handleChange}
                                                value={this.state.last_name}/>
                                            <span className="error-text">{this.state.last_nameError}</span>
                                        </label>
                                        <label>
                                            Sex
                                            <select 
                                                name="sex" 
                                                className={this.state.sexError && 'error-input'} 
                                                onChange={this.handleChange}
                                                value={this.state.sex}>
                                                <option value="">Select...</option>
                                                <option value="Male">Male</option>
                                                <option value="Female">Female</option>
                                            </select>
                                            <span className="error-text">{this.state.sexError}</span>
                                        </label>
                                        <label>
                                            Date of birth
                                            <input 
                                                type="date" 
                                                name="dob" 
                                                className={this.state.dobError && 'error-input'} 
                                                onChange={this.handleChange}
                                                value={this.state.dob}/>
                                            <span className="error-text">{this.state.dobError}</span>
                                        </label>
                                        <label>
                                            Marital Status
                                            <select 
                                                name="marital_status" 
                                                className={this.state.marital_statusError && 'error-input'} 
                                                onChange={this.handleChange}
                                                value={this.state.marital_status}>
                                                <option value="">Select...</option>
                                                <option value="single">Single</option>
                                                <option value="married">Married</option>
                                                <option value="seperated">Separated</option>
                                                <option value="divorced">Divorced</option>
                                                <option value="widowed">Widowed</option>
                                            </select>
                                            <span className="error-text">{this.state.marital_statusError}</span>
                                        </label>
                                        <label>
                                            Address
                                            <input 
                                                type="text" 
                                                name="address" 
                                                className={this.state.addressError && 'error-input'} 
                                                onChange={this.handleChange}
                                                value={this.state.address}/>
                                            <span className="error-text">{this.state.addressError}</span>
                                        </label>
                                        <label>
                                            State
                                            <select 
                                                name="state" 
                                                className={this.state.stateError && 'error-input'} 
                                                onChange={this.handleChange}
                                                // onLeave={() => {console.log('onLeave')}}
                                                onBlur={() => this.handleLgas()}
                                                value={this.state.state}>
                                                <option value="">Select...</option>
                                                {stateOption}
                                            </select>
                                            <span className="error-text">{this.state.stateError}</span>
                                        </label>
                                        <label>
                                            LGA
                                            <select 
                                                name="lga" 
                                                className={this.state.lgaError && 'error-input'} 
                                                onChange={this.handleChange}
                                                value={this.state.lga}>
                                                <option value="">Select...</option>
                                                {lgaOption}
                                            </select>
                                            {!lgaResponse && <img src={inputLoader} alt='' className='input-loader'/>}
                                            <span className="error-text">{this.state.lgaError}</span>
                                        </label>
                                        <label>
                                            Phone Number
                                            <input 
                                                type="text" 
                                                name="phone_no" 
                                                className={this.state.phone_noError && 'error-input'} 
                                                onChange={this.handleChange}
                                                value={this.state.phone_no}/>
                                            {!phone_noResponse && <img src={inputLoader} alt='' className='input-loader'/>}
                                            <span className="error-text">{this.state.phone_noError}</span>
                                        </label>
                                        <label>
                                            Occupation
                                            <input 
                                                type="text" 
                                                name="occupation" 
                                                className={this.state.occupationError && 'error-input'} 
                                                onChange={this.handleChange}
                                                value={this.state.occupation}/>
                                            <span className="error-text">{this.state.occupationError}</span>
                                        </label>
                                        <label>
                                            Weight
                                            <input 
                                                type="number" 
                                                name="weight" 
                                                className={this.state.weightError && 'error-input'} 
                                                onChange={this.handleChange}
                                                value={this.state.weight}/>
                                            <span>Kg</span>
                                            <span className="error-text">{this.state.weightError}</span>
                                        </label>
                                        <label>
                                            Height
                                            <input 
                                                type="number" 
                                                name="height" 
                                                className={this.state.heightError && 'error-input'} 
                                                onChange={this.handleChange}
                                                value={this.state.height}/>
                                            <span>Metres</span>
                                            <span className="error-text">{this.state.heightError}</span>
                                        </label>
                                        <p className="prev-error-text">{this.state.page_error}</p>
                                        <label>
                                            Site of disease
                                            <select 
                                                name="sod" 
                                                className={this.state.sodError && 'error-input'} 
                                                onChange={this.handleChange}
                                                value={this.state.sod}>
                                                <option value="">Select...</option>
                                                <option value="Pulmonary">Pulmonary (P)</option>
                                                <option value="Extrapulmonary">Extrapulmonary (EP)</option>
                                            </select>
                                            <span className="error-text">{this.state.sodError}</span>
                                        </label>
                                        <label>
                                            Who referred patient
                                            <select 
                                                name="referral" 
                                                className={this.state.referralError && 'error-input'} 
                                                onChange={this.handleChange}
                                                value={this.state.referral}>
                                                <option value="">Select...</option>
                                                <option value="ART facility">ART facility</option>
                                                <option value="DOTS facility">DOTS facility</option>
                                                <option value="TB patient">TB patient</option>
                                                <option value="OPD">OPD</option>
                                                <option value="CV">CV</option>
                                                <option value="TS">TS</option>
                                                <option value="CTW">CTW</option>
                                                <option value="PPM Scheme 1 facility">PPM Scheme 1 facility</option>
                                                <option value="Others">Others</option>
                                            </select>
                                            <span className="error-text">{this.state.referralError}</span>
                                        </label>
                                        <div className="error-cont"><span className="prev-error-text">{this.state.page_error}</span></div>
                                        <button onClick={this.handleNextPage}>Submit</button>
                                    </div>
                                {!this.state.noResponse && <div className="loader"><img src={xsmallLoader} alt=''/></div>}
                            </form>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        )
    }
}

export default EnrollmentForm;


// WEBPACK FOOTER //
// ./src/components/EnrollmentForm.js